'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Portal = require('./components/Portal.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Portal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-portal/lib/index.js
// module id = 894
// module chunks = 0 1